import { render, staticRenderFns } from "./PriceWorkflowDashboards.vue?vue&type=template&id=22d38dbe&scoped=true&"
import script from "./PriceWorkflowDashboards.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowDashboards.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowDashboards.vue?vue&type=style&index=0&id=22d38dbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d38dbe",
  null
  
)

export default component.exports